import React, { useState } from "react";
import "./Navbar.css";

const Navbar = ({ setActiveSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("hero");

  const handleNavClick = (e, section) => {
    e.preventDefault();
    window.location.hash = section;
    setActiveSection(section);
    setActiveLink(section); // track active link
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="logo">My Portfolio</div>

      <div
        className={`menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <a
            href="#hero"
            className={activeLink === "hero" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "hero")}
          >
            Home
          </a>
        </li>
        <li>
          <a
            href="#about"
            className={activeLink === "about" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "about")}
          >
            About
          </a>
        </li>
        <li>
          <a
            href="#resume"
            className={activeLink === "resume" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "resume")}
          >
            Resume
          </a>
        </li>
        <li>
          <a
            href="#services"
            className={activeLink === "services" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "services")}
          >
            Services
          </a>
        </li>
        <li>
          <a
            href="#projects"
            className={activeLink === "projects" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "projects")}
          >
            Projects
          </a>
        </li>
        <li>
          <a
            href="#contact"
            className={activeLink === "contact" ? "active-link" : ""}
            onClick={(e) => handleNavClick(e, "contact")}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
